module.exports = __webpack_public_path__ + "static/media/CV2026May.d7d31e5f.pdf";